export enum AppConfigType {
    directFlights = 1,
    inactivityTime = 2,
    biometrics = 3,
    holdItemListWarnings = 4,
    shortFrequencyWarnings = 5,
    nextScheduleWarning = 6,
    engineWarmUpCoolDownTimeBuffer = 7,
    prefillCopilotPlanFlights = 8,
    prefillCopilotDirectFlights = 9,
    penaltyFactor = 10,
    plannedFlightsToAll = 11,
    planFlights = 12,
    tabletOrientation = 13,
    enginePowerCheck = 14,
    passengers = 15,
    crew = 16,
    flightSpecifications = 17,
    flightTypeNotes = 18,
    flightRefuelLocation = 19,
    massBalance = 20,
    dailyCheck = 21,
    preventClosingPage = 22,
    engineTimingInsertion = 23,
    hotRefuelFlight = 24,
    hooks = 25,
    positioningFlight = 26,
    enginesForm = 27,
    flightNumber = 28,
    vemd = 29,
    keyboardTimePicker = 30,
    initialPreviousFlights = 31,
    hoist = 32,
    pob = 33,
    approveDocument = 34,
    nightInspectionHoist = 35,
    flightEditing = 36,
    maxTankCapacity = 37,
    massBalanceCode = 38,
    exportPresetFilters = 39,
    aircraftActivityList = 40,
    pilotActivityList = 41,
    numpadIOS26 = 42,
    veryon = 43,
    airMaestro = 44,
    remarksDefectsActionsTaken = 45,
    oilUnits = 46,
    fuelUnits = 47,
    flightCard = 48,
    warningLongDuration = 49,
    flightOperations = 50,
    timezone = 51,
    acCycles = 52,
    autoLock = 53,
}

export class AppConfig {
    type: number;
    enabled: boolean;
    value?: any;
}
